import React from 'react';
import { Avatar, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment/moment';
import useSession from '../../../hooks/useSession';

const useStyle = makeStyles((theme) => ({
  container: {
    borderRadius: '12px',
    border: '1px solid #D0D0D0',
    padding: '1rem',
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  header: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    fontFamily: 'Urbanist-Medium',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#022752',
  },
  date: {
    fontSize: '0.875rem',
    fontFamily: 'Urbanist-Regular',
    color: '#535353',
    marginLeft: '1rem',
  },
  content: {
    fontFamily: 'Urbanist-Regular',
    fontSize: '1rem',
    color: '#707070',
    marginTop: '1rem',
  },
}));

const ReplyCard = ({ reply }) => {
  const classes = useStyle();
  const { user } = useSession();
  const { content, createdAt, userNameWithInitial } = reply;

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Avatar
          sx={{
            width: '2.5rem',
            height: '2.5rem',
            marginRight: '1rem',
            bgcolor: '#f1f1f1 !important',
            cursor: 'pointer',
          }}
        >
          {user?.profilePicture?.data !== '' ? (
            <img
              src={user?.profilePicture}
              alt="Profile"
              style={{ width: '100%', height: '100%', borderRadius: '50%' }}
            />
          ) : (
            <Typography variant="h3">{`${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`}</Typography>
          )}
        </Avatar>
        <Typography className={classes.name}>{userNameWithInitial}</Typography>
        <Typography className={classes.date}>
          {moment().diff(createdAt, 'days') === 0
            ? moment(createdAt).format('h:mm a')
            : moment().diff(createdAt, 'days') <= 7
              ? moment(createdAt).fromNow()
              : moment(createdAt).format('DD/MM/YY')}
        </Typography>
      </div>
      <Typography className={classes.content}>{content}</Typography>
    </div>
  );
};

export default ReplyCard;
